export default {
  primary: {
    backgroundColor: 'transparent',
    color: 'light',
    textTransform: 'uppercase',
    fontFamily: 'subheading',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.8rem'],
    padding: '1rem 2.5rem',
    fontWeight: 'bold',
    transition: 'all ease-in-out 0.5s',
    border: 'solid 1px white',
    borderRadius: '0px',
    ':hover': {
      backgroundColor: 'primary',
      borderColor: 'white'
    }
  },
  secondary: {
    color: 'light',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '1rem',
    transition: 'all ease-in-out 0.5s',
    ':hover': {
      backgroundColor: 'secondary',
      borderColor: 'white'
    }
  }
}
